import apiClient from './api';
import { apiService } from './api';
import { MenuItemDTO, MenuItemListDTO, CreateMenuItemDTO, CreateMenuItemRecipeDTO } from '../types';
import { ApiResponse } from '../types';

const API = '/menu-items';

export const menuItemService = {
  /**
   * Uploads a (client-compressed) menu item image and returns its URL.
   * `Content-Type: null` drops the JSON default so axios/the browser can set
   * the correct multipart boundary — see companySettingsService.uploadLogo.
   */
  uploadImage: (file: File) => {
    const form = new FormData();
    form.append('image', file);
    return apiClient.post<ApiResponse<{ imageUrl: string }>>(
      `${API}/upload-image`,
      form,
      { headers: { 'Content-Type': null } },
    );
  },

  getAll: (pageNumber = 1, pageSize = 100) =>
    apiService.get<{ data: MenuItemListDTO[] }>(API, { pageNumber, pageSize }),

  getByCategory: (categoryId?: number) =>
    apiService.get<{ data: MenuItemListDTO[] }>(API, categoryId ? { categoryId, pageNumber: 1, pageSize: 200 } : { pageNumber: 1, pageSize: 200 }),

  getById: (id: number) =>
    apiService.get<MenuItemDTO>(`${API}/${id}`),

  create: (data: CreateMenuItemDTO) =>
    apiService.post<MenuItemDTO>(API, data),

  update: (id: number, data: Partial<CreateMenuItemDTO>) =>
    apiService.put<MenuItemDTO>(`${API}/${id}`, data),

  updateRecipes: (id: number, recipes: CreateMenuItemRecipeDTO[]) =>
    apiService.put<MenuItemDTO>(`${API}/${id}/recipes`, recipes),

  delete: (id: number) =>
    apiService.delete<boolean>(`${API}/${id}`),
};
